<template>
  <el-dialog
    :visible.sync="visible"
    @close="close"
    custom-class="upgradeNotification"
    title="爱原物版本升级通知"
    top="25vh"
    width="458px"
  >
    <div class="notificationContent">
      <b class="title">尊敬的用户：</b>
      <p>
        爱原物智能体版本升级中，<b>「需求解析与设计」</b>
        的功能1月28日（周三）开始停服到2月2日（下周一）；
      </p>
      <p>
        非常感谢您的理解和支持，我们将为所有该权限会员自动延长一周会员时间；
      </p>
      <p>暂停是为了更好的前行，敬请期待～</p>
    </div>
    <div slot="footer">
      <el-button type="primary" @click="close">我知道了</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  watch: {
    show: {
      handler(val) {
        this.visible = val;
      },
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    close() {
      this.$emit("update:show", false);
    },
  },
};
</script>
<style lang="scss">
.upgradeNotification {
  background-image: url("../assets/notification.png") !important;
  background-size: 100% 100% !important;
  border-radius: 10px !important;
  .el-dialog__header {
    padding: 28px 24px 0;
    .el-dialog__title {
      font-weight: 600;
      font-size: 18px;
      color: #2858f8;
    }
    .el-dialog__close {
      font-size: 18px;
      font-weight: 600;
    }
  }
  .el-dialog__body {
    padding: 27px 24px;
    .notificationContent {
      .title {
        font-size: 14px;
        color: #333333;
        line-height: 20px;
      }
      p {
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        line-height: 24px;
        margin-top: 12px;
      }
    }
  }
  .el-dialog__footer {
    padding: 0px 24px 24px;
    .el-button {
      width: 88px;
      height: 38px;
      border-radius: 4px;
      font-size: 14px;
    }
  }
}
</style>
